const initialState = {
	list: [],
	page: 1,
	isListNext: false,
	datetime: null,
	scrollpos: 0,
};

export default function reducer(state = initialState, action) {
	if (action.type === 'COMMUNITY_POST_LIST_SET') {
		let newState = Object.assign({}, state);
		newState.list = action.payload.list;
		newState.page = action.payload.page;
		newState.isListNext = action.payload.isListNext;
		newState.datetime = (new Date());
		return newState;
	}
	else if (action.type === 'COMMUNITY_POST_ITEM_SET') {
		let newState = Object.assign({}, state);

		if (action.payload.type === 'del') {
			let list = newState.list.filter((value) => (value.userdata_id_code !== action.payload.pic));
			newState.list = list;
		}
		return newState;
	}
	else if (action.type === 'COMMUNITY_POST_GOOD_SET') {
		let newState = Object.assign({}, state);
		let index = newState.list.findIndex((v) => v.post_id === action.payload.postId);

		if (index >= 0) {
			newState.list[index]['good_count'] = action.payload.goodCount;
			newState.list[index]['post_good_sended'] = action.payload.goodSended;
		}
		return newState;
	}
	else if (action.type === 'COMMUNITY_POST_SCROLLPOS_SET') {
		let newState = Object.assign({}, state);
		newState.scrollpos = action.payload.scrollpos;
		return newState;
	}
	else {
		return state;
	}
}
